var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bookServiceMOT" }, [
    _c(
      "div",
      { staticClass: "bookServiceMOT__tabs" },
      _vm._l(_vm.vehicleTypes, function (type) {
        return _c(
          "button",
          {
            key: type.value,
            staticClass: "bookServiceMOT__tab",
            class: {
              "bookServiceMOT__tab--active": type.value === _vm.vehicleType,
            },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.onVehicleType(type.value)
              },
            },
          },
          [
            type.logo
              ? _c(type.logo, {
                  tag: "Component",
                  attrs: { "is-white": type.value === _vm.vehicleType },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", { class: { "sr-only": type.logo } }, [
              _vm._v(_vm._s(type.label)),
            ]),
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "bookServiceMOT__wrap" }, [
      _vm.vehicleType === "carz"
        ? _c("div", { staticClass: "bookServiceMOT__body" }, [
            _c(
              "form",
              {
                staticClass: "sfServiceBookingForm__form",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.onSubmit($event)
                  },
                },
              },
              [
                _c("div", { staticClass: "sfServiceBookingForm__row" }, [
                  _c(
                    "label",
                    { staticClass: "sr-only", attrs: { for: "vrm" } },
                    [_vm._v("Registration number")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sfServiceBookingForm__inputWrap" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.vrm,
                            expression: "vrm",
                          },
                        ],
                        staticClass: "sfServiceBookingForm__input",
                        attrs: {
                          type: "text",
                          name: "reg_num",
                          id: "vrm",
                          placeholder: "Enter vehicle reg",
                        },
                        domProps: { value: _vm.vrm },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.vrm = $event.target.value
                            },
                            _vm.onInput,
                          ],
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sfServiceBookingForm__row" }, [
                  _c(
                    "label",
                    { staticClass: "sr-only", attrs: { for: "mileage" } },
                    [_vm._v("Mileage")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sfServiceBookingForm__inputWrap" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.mileage,
                            expression: "mileage",
                            modifiers: { number: true },
                          },
                        ],
                        staticClass: "sfServiceBookingForm__input",
                        attrs: {
                          type: "number",
                          name: "mileage",
                          id: "mileage",
                          placeholder: "Enter mileage",
                        },
                        domProps: { value: _vm.mileage },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.mileage = _vm._n($event.target.value)
                            },
                            _vm.onInput,
                          ],
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sfServiceBookingForm__row" }, [
                  _c(
                    "label",
                    { staticClass: "sr-only", attrs: { for: "location" } },
                    [_vm._v("Location")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sfServiceBookingForm__selectWrap" },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.location,
                              expression: "location",
                            },
                          ],
                          staticClass: "sfServiceBookingForm__select",
                          attrs: { name: "location", id: "location" },
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.location = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              _vm.onInput,
                            ],
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Location"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.carzLocations, function (location) {
                            return _c(
                              "option",
                              { domProps: { value: location.id } },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(location.name) +
                                    "\n                            "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "sfServiceBookingForm__button",
                    attrs: { type: "submit", disabled: _vm.isFormDisabled },
                  },
                  [_vm._v("\n                    Book now\n                ")]
                ),
              ]
            ),
            _vm._v(" "),
            (_vm.isFlyout && _vm.isFlyoutOpen && _vm.valid) ||
            (!_vm.isFlyout && _vm.valid)
              ? _c(
                  "div",
                  {
                    staticClass: "sfServiceBookingForm__iframeContainer",
                    class: {
                      "sfServiceBookingForm__iframeContainer--flyout":
                        _vm.isFlyout && _vm.valid && _vm.isFlyoutOpen,
                    },
                  },
                  [
                    _vm.isFlyout && _vm.isFlyoutOpen
                      ? _c(
                          "button",
                          {
                            staticClass: "sfServiceBookingForm__close",
                            attrs: { type: "button" },
                            on: { click: _vm.onFlyoutClose },
                          },
                          [
                            _c("span", {
                              staticClass: "sfServiceBookingForm__close__lines",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Close"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("iframe", {
                      attrs: {
                        src: _vm.iframeUrl,
                        width: "100%",
                        height: "600",
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ])
        : _c("div", { staticClass: "bookServiceMOT__body" }, [
            _c("div", { staticClass: "bookServiceMOT__content" }, [
              _c("h2", { staticClass: "bookServiceMOT__contentTitle" }, [
                _vm._v(_vm._s(_vm.selectedVehicleType.label)),
              ]),
              _vm._v(" "),
              _vm.selectedVehicleType.addresses.length
                ? _c(
                    "div",
                    { staticClass: "bookServiceMOT__addresses" },
                    _vm._l(
                      _vm.selectedVehicleType.addresses,
                      function (address) {
                        return _c(
                          "div",
                          { staticClass: "bookServiceMOT__address" },
                          [
                            _c("div", {
                              domProps: { innerHTML: _vm._s(address.address) },
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "bookServiceMOT__button",
                                attrs: {
                                  href: "tel:" + address.phone.replace(" ", ""),
                                },
                              },
                              [_vm._v("Call us on " + _vm._s(address.phone))]
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedVehicleType.content !== ""
                ? _c("div", {
                    staticClass: "bookServiceMOT__additionalContent",
                    domProps: {
                      innerHTML: _vm._s(_vm.selectedVehicleType.content),
                    },
                  })
                : _vm._e(),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }